import Cookies from 'js-cookie/src/js.cookie.js';

export default {
  init() {
    // JavaScript to be fired on all pages
	$('.modal-open, #modal-book .modal-close').on('click', function() {
		$('#modal-book').toggleClass('show');
		$('html').toggleClass('modal-active');
	});
	
	$('#filter').keyup(function () {
		var rex = new RegExp($(this).val(), 'i');
		$('.searchable').hide();
		$('.searchable').filter(function () {
			return rex.test($(this).text());
		}).show();
	})
	
    $('#cookie-close-announcement').click(function() {
		$('#cookie-box-announcement').addClass('hide');
		Cookies.set('cookie-box-announcement-accept', 'accepted', {
			expires: 1, 
		});
	});
	if (Cookies.get('cookie-box-announcement-accept') == ('accepted')) {
		$('#cookie-box-announcement').addClass('hide');
	} else {
		$('#cookie-box-announcement').removeClass('hide');
	}
	
	$('#cookie-close-cookies').click(function() {
		$('#cookie-box-cookies').addClass('hide');
		Cookies.set('cookie-close-cookies-accept', 'accepted', {
			expires: 30,
		});
	});
	if (Cookies.get('cookie-close-cookies-accept') == ('accepted')) {
		$('#cookie-box-cookies').addClass('hide');
	} else {
		$('#cookie-box-cookies').removeClass('hide');
	}
	
	$('.scrolldown').click(function() {
	$('html, body').animate({
	scrollTop: $($(this).attr('href')).offset().top - 120, 
	}, 400);
	return false;
	});
	
	function checkScrollPrimary() {
		var startY = $('.navbar-primary').height();
		if ($(window).scrollTop() > startY) {
			$('header').addClass('scrolled');
		} else {
			$('header').removeClass('scrolled');
		}
	}
	
	if ($('header').length > 0) {
		$(window).on('scroll load resize', function() {
			checkScrollPrimary();
		});
	}
	
	$(function() {
		$('.two-lines').html(function() {
			var html = $(this).html().split(' ');
			html = html[0] + '<br />' + html.slice(1).join(' ');
			$(this).html(html);
		});
	})
	
	$('.slider-announcement .slider-inner').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		dots: false,
		infinite: true,
		speed: 500,
		vertical: true,
		draggable: false,
		cssEase: 'ease-in',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					vertical: false,
				},
			},
		],
	});
	
	$('.slider-hero .slider-inner').slick({
		dots: false,
		fade: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 5000,
		cssEase: 'ease-in',
		appendArrows: '.slider-hero .slider-control',
	});
	
	$('.slider-spaces .slider-inner').slick({
		dots: false,
		infinite: false,
		speed: 500,
		variableWidth: true,
		swipeToSlide: true,
		cssEase: 'ease-in',
		prevArrow: '.module-spaces-slider .slider-control .slider-prev',
		nextArrow: '.module-spaces-slider .slider-control .slider-next',
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					centerMode: false,
					autoplay: false,
					variableWidth: false,
					adaptiveHeight: true,
				},
			},
		],
	});
	
	$('.slider-experts .slider-inner').slick({
		dots: false,
		infinite: true,
		speed: 500,
		variableWidth: true,
		swipeToSlide: true,
		cssEase: 'ease-in',
		appendArrows: '.slider-experts .slider-control',
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					centerMode: false,
					variableWidth: false,
					adaptiveHeight: true,
				},
			},
		],
	});
	
	$('.slider-testimonials .slider-inner').slick({
		arrows: false,
		dots: false,
		fade: true,
		speed: 500,
		infinite: false,
		swipe: false,
		swipeToSlide: false,
		cssEase: 'ease-in',
		asNavFor: '.slider-testimonials-nav .slider-inner',
	});
	
	$('.slider-testimonials-nav .slider-inner').slick({
		asNavFor: '.slider-testimonials .slider-inner',
		arrows: false,
		infinite: false,
		speed: 500,
		dots: false,
		focusOnSelect: true,
		variableWidth: true,
		swipe: true,
		swipeToSlide: true,
		draggable: false,
		cssEase: 'ease-in',
	});
	
	$('.slider-cocktail .slider-inner').slick({
		dots: false,
		fade: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 5000,
		swipe: false,
		swipeToSlide: false,
		cssEase: 'ease-in',
	});
	
	$('.slider-projects .slider-inner').slick({
		arrows: false,
		dots: false,
		infinite: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 3000,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
	});
	
	$('a[data-slide]').click(function(e) {
		e.preventDefault();
		var slideno = $(this).data('slide');
		$('.slider-testimonials-nav .slider-inner').slick('slickGoTo', slideno - 1);
	});
	
	$('.module-services-complete .btn').mouseover(function() {
		$('.module-services-complete .thumbnail').removeClass('active');
		$('.module-services-complete #image' + $(this).attr('data-image')).addClass('active');
	});
	
	$('.archive-lastest .experts a').mouseover(function() {
		$('.archive-lastest .experts .thumbnail').removeClass('active');
		$('.archive-lastest .experts #image' + $(this).attr('data-image')).addClass('active');
	});
	},
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js